import ClentCheckMyemsContainer from "../containers/ClentCheckMyemsContainer";

const ClientCheckMyemsPage = () => {

    return <ClentCheckMyemsContainer/>
};

export default ClientCheckMyemsPage;